// eslint-disable-next-line import/no-cycle
import accountRequestService from '@client/services/accountRequest';

const stateObj = {
  current: {
    officialName: '',
    officialTitle: '',
    officialOrganization: '',
    relationship: '',
    countryCodeISOAlpha2: '',
  },
  isSet: null,
};

const getters = {};

const actions = {
  set({commit}, payload) {
    if (payload) {
      commit('SET', payload);
    }
  },
  async save({commit, rootState, rootGetters}, politicalExposureDetail) {
    let publicOfficialInformation = null;

    // eslint-disable-next-line camelcase
    const requests = rootState.account.requests.current.map(({request_id, request_initiated_from}) =>
      accountRequestService.updateAccountRequest({
        clUserId: rootGetters['cognitoUser/userId'],
        id: request_id,
        requestInitiator: request_initiated_from,
        disclosures: {politicalExposureDetail},
      })
    );

    const [response] = await Promise.all(requests);

    if (response.disclosures) {
      publicOfficialInformation = response.disclosures.politicalExposureDetail;
      commit('SET', publicOfficialInformation);
    }

    return publicOfficialInformation;
  },
};

const mutations = {
  SET(state, payload) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {disable, ...requiredDetails} = payload;

    state.current = requiredDetails;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
